import { cloneDeep, set } from 'lodash-es';
import { SessionAppData, SessionAppDataUpdates, SessionCookie } from './session-cookie.types';

/**
 * Aplica updates sobre `app`, resolviendo las rutas con dot notation
 * (ej. `'selectedSubsidiaryMap.mitienda'`).
 *
 * Vive acá y no en la lib de backend porque la usan los dos lados: el servidor al mergear contra la
 * cookie del request, y el cliente al aplicar el patch sobre su estado local. Compartirla garantiza
 * que ambos lleguen al mismo resultado.
 */
export function applyAppDataUpdates(
  app: SessionAppData = {},
  updates: SessionAppDataUpdates = {},
): SessionAppData {
  const appData = cloneDeep(app);

  for (const [key, value] of Object.entries(updates)) {
    set(appData, key, value);
  }

  return appData;
}

/**
 * Merge flexible con soporte de dot notation (estilo Firebase update)
 */
export function updateAppData(
  session: SessionCookie | null = {},
  updates: SessionAppDataUpdates = {},
): SessionCookie {
  return {
    ...session,
    app: applyAppDataUpdates(session?.app, updates),
  };
}

export function isNewSessionCookie(session: unknown): session is SessionCookie {
  return (
    session !== null &&
    session !== undefined &&
    typeof session === 'object' &&
    !Array.isArray(session)
  );
}
